module.exports = __webpack_public_path__ + "media/views/about/images/location-a4646e23318944a80d0f3eb568265cf5.svg";